import React from 'react';
import { Badge } from '../ui/badge';
import { aboutContent } from '../../data/mock';

export const About = () => {
  return (
    <section id="quem-somos" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center">
          <Badge className="mb-6 bg-teal-100 text-teal-700 border-teal-200 hover:bg-teal-100">
            {aboutContent.badge}
          </Badge>
          
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 mb-6 leading-tight">
            {aboutContent.title}
          </h2>
          
          <p className="text-lg text-slate-600 mb-8 leading-relaxed">
            {aboutContent.description}
          </p>
          
          {aboutContent.paragraphs.map((paragraph, index) => (
            <p key={index} className="text-slate-600 mb-4 leading-relaxed">
              {paragraph}
            </p>
          ))}
        </div>
      </div>
    </section>
  );
};
